import { useEffect } from 'react';

/**
 * Hook to apply global interceptors to fetch API.
 * This overrides the global fetch function to add 403 handling.
 */
const useFetchInterceptor = () => {
  useEffect(() => {
    const originalFetch = window.fetch;
    
    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);
      
      // Handle 403 status
      // if (response.status === 403) {
      //   console.log('403 Forbidden response received from fetch API - logging out user');
      //   localStorage.removeItem('token');
      //   localStorage.removeItem('user');
      //   window.location.href = '/login';
      // }
      
      return response;
    };
    
    // Cleanup function - restore original fetch
    return () => {
      window.fetch = originalFetch;
    };
  }, []);
};

export default useFetchInterceptor; 